module.exports = __webpack_public_path__ + "static/img/photo3.f0661183.jpg";